export default class Response {
  private status: boolean = false
  private payload: any = {}

  constructor (status:boolean, payload:any) {
    this.status = status
    this.payload = payload
  }

  public isOk () : boolean {
    return this.status
  }

  public checkErrorStatus () : boolean {
    if (this.payload.message === '404' || this.payload.message === 'Failed to fetch') {
      return true
    }
    return false
  }

  public checkServerErrorStatus () : boolean {
    if (this.payload.message === '500' ||
        this.payload.message === '501' ||
        this.payload.message === '502' ||
        this.payload.message === '503' ||
        this.payload.message === '504' ||
        this.payload.message === '505' ||
        this.payload.message === '506' ||
        this.payload.message === '507' ||
        this.payload.message === '508' ||
        this.payload.message === '509' ||
        this.payload.message === '510') {
      return true
    }
    return false
  }

  public getPayload () : any {
    return this.payload
  }
}
